// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {postDebit} from '../../shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateFullDebitModalVisibility} from './claim-debit';

export const submitFullDebit = debit =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await postDebit(debit);

            successAlertBar(translate('DEBIT_SUBMITTED_SUCCESSFULLY'));

            updateFullDebitModalVisibility(false)(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/action-creators/submit-debit.js